export const handleAWBNumberInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nativeEvent = e.nativeEvent as InputEvent;
    const inputValue = e.target.value;
    if (nativeEvent.inputType === "deleteContentBackward" || nativeEvent.inputType === "deleteByCut") {
        let trimInput = inputValue.trim() === "" ? "" : inputValue.slice(0, -1);
        return trimInput;
    }
    if (inputValue.trim() === "") { return ""; }
    let fmt = inputValue
        .replace(/[\r\n]+/g, ",")
        .replace(/\s*,\s*/g, ",")
        .replace(/[^0-9,]/g, "")
        .trim();
    fmt = fmt
        .split(",")
        .filter(a => a.trim() !== ",")
        .map(awb => {
            if (nativeEvent.inputType !== "insertText") {
                if (awb.length === 9) awb = "00" + awb;
                else if (awb.length === 10) awb = "0" + awb;
            }
            if (awb.length > 3 && awb[3] !== "-") awb = awb.slice(0, 3) + "-" + awb.slice(3);
            return awb;
        })
        .join(",");
    return (fmt);
};



// ── Ocean tracking number input handler ──────────────────────────────────────
// Adapted from handleOceanInput but works on <input> and returns the
// formatted string instead of calling a setter directly.
export function handleOceanNumberInput(e: React.ChangeEvent<HTMLInputElement>): string {
  let v = e.target.value
    .replace(/[\r\n]+/g, ',')
    .replace(/\s*,\s*/g, ',')
    .replace(/\s+/g, ',')
    .replace(/[^A-Z0-9,-]/gi, '')
    .toUpperCase()
    .trim();

  v = v
    .split(',')
    .map((awb) => {
      awb = awb.trim();
      if (!awb) return '';
      // Auto-insert dash before last 4 alpha chars if missing
      if (!awb.includes('-') && awb.length > 7) {
        const suffix = awb.slice(-4);
        if (/^[A-Z]{4}$/.test(suffix)) return `${awb.slice(0, -4)}-${suffix}`;
      }
      return awb;
    })
    .filter((a) => a !== '')
    .join(',');

  return v;
}
